// ChatwootWidget.js
import { UserContext } from "@context/UserContext";
import OrderServices from "@services/OrderServices";
import { useContext, useEffect, useState } from "react";
import crypto from "crypto";
import Cookies from 'js-cookie';

const ChatwootWidget = () => {
  const {
    state: { userInfo },
  } = useContext(UserContext);

  const [runChatWoot, setRunChatWoot] = useState(false);

  useEffect(() => {
    window.chatwootSettings = {
      hideMessageBubble: false,
      position: "left",
      locale: "en",
      type: "bubble", //expanded_bubble, bubble
    };

    (function (d, t) {
      var BASE_URL = "https://app.chatwoot.com";

      var g = d.createElement(t),
        s = d.getElementsByTagName(t)[0];

      g.src = BASE_URL + "/packs/js/sdk.js";

      g.defer = true;

      g.async = true;

      s.parentNode.insertBefore(g, s);

      g.onload = function () {
        window.chatwootSDK.run({
          websiteToken: "hvcRtENzPuGELvgmBmkzwVsy",

          baseUrl: BASE_URL,
          customCSS: "button{padding: 100px}",
        });
        setRunChatWoot(true);
      };
    })(document, "script");
  }, []); useEffect(() => {
    if (runChatWoot && userInfo && userInfo._id) {
      try {
        const key = "zyTBrTPME9kTrzjPJsnxTsb3";
        const hash = crypto
          .createHmac("sha256", key)
          .update(userInfo._id)
          .digest("hex");

        window.$chatwoot.setUser(userInfo._id, {
          email: userInfo.email,
          name: userInfo.name,
          avatar_url: userInfo.image ? userInfo.image : null,
          phone_number: userInfo.phone ? userInfo.phone : null,
          identifier_hash: hash,
        });

        const date = userInfo.signed_up_on
          ? new Date(userInfo.signed_up_on).toLocaleDateString("en-us", {
            year: "numeric",
            month: "short",
            day: "numeric",
          })
          : new Date().toLocaleDateString("en-us", {
            year: "numeric",
            month: "short",
            day: "numeric",
          });

        let order = [];
        const retriveOrder = async () => {
          let orderCount = 0;
          let customerValue = 0;

          try {
            order = await OrderServices.getOrderByUserWithTotal();
            orderCount = order?.count || 0;
            customerValue = order?.total || 0;
          } catch (err) {
            console.log(err);
          }

          // Create updated userInfo with order data (regardless of success/failure)
          const updatedUserInfo = {
            ...userInfo,
            order_count: orderCount,
            customer_value: customerValue
          };

          // Update the cookie with order information
          Cookies.set("userInfo", JSON.stringify(updatedUserInfo), {
            expires: 200,
          });

          // Set Chatwoot custom attributes
          window.$chatwoot.setCustomAttributes({
            signed_up_on: date, // Pull account creation date from mongodb
            verfied_through: userInfo.verfied_through || 'unknown', //Whichever platform the user has verified on will be added and separated by comma
            order_count: orderCount, // Pull total order placed count
            customer_value: customerValue, // Pull customer's order total for all orders on status "Delivered"
          });
        };
        retriveOrder();
      } catch (error) {
        console.error('Error setting up Chatwoot user:', error);
      }
    }
  }, [userInfo, runChatWoot]);

  return null;
};

export default ChatwootWidget;
